import * as yup from "yup";

const PaymentInfoStepValidation = yup.object().shape({
	invoiceInfo: yup.object().shape({
		nameSurname: yup.string().when("isCompany", {
			is: false,
			then: yup.string().required(),
		}),
		identityId: yup.number().when("isCompany", {
			is: false,
			then: yup
				.number()
				.required()
				.test(
					"identityIdLength",
					"Tc Kimlik Numarası 11 karakterden oluşmalıdır.",
					(val) => {
						if (val?.toString().length !== 11) {
							return false;
						}
						const pr11 = val % 10;
						const pr10 = ((val - (val % 10)) % 100) / 10;
						const pr9 = ((val - (val % 100)) % 1000) / 100;
						const pr8 = ((val - (val % 1000)) % 10000) / 1000;
						const pr7 = ((val - (val % 10000)) % 100000) / 10000;
						const pr6 = ((val - (val % 100000)) % 1000000) / 100000;
						const pr5 = ((val - (val % 1000000)) % 10000000) / 1000000;
						const pr4 = ((val - (val % 10000000)) % 100000000) / 10000000;
						const pr3 =
							((val - (val % 100000000)) % 1000000000) / 100000000;
						const pr2 =
							((val - (val % 1000000000)) % 10000000000) / 1000000000;
						const pr1 =
							((val - (val % 10000000000)) % 100000000000) / 10000000000;

						if (
							(pr1 +
								pr3 +
								pr5 +
								pr7 +
								pr9 +
								pr2 +
								pr4 +
								pr6 +
								pr8 +
								pr10) %
								10 !==
							pr11
						) {
							return false;
						}

						if (
							((pr1 + pr3 + pr5 + pr7 + pr9) * 7 +
								(pr2 + pr4 + pr6 + pr8) * 9) %
								10 !==
							pr10
						) {
							return false;
						}

						if (((pr1 + pr3 + pr5 + pr7 + pr9) * 8) % 10 !== pr11) {
							return false;
						}

						return true;
					}
				),
		}),
		company: yup.string().when("isCompany", {
			is: true,
			then: yup.string().required(),
		}),
		taxAdmin: yup.string().when("isCompany", {
			is: true,
			then: yup.string().required(),
		}),
		taxNo: yup.string().when("isCompany", {
			is: true,
			then: yup.string().required(),
		}),
		address: yup.string().required(),
		district: yup.string().required(),
		province: yup.string().required(),
		country: yup.string().required(),
	}),
	deliveryInfo: yup.object().shape({
		nameSurname: yup.string().required(),
		company: yup.string().required(),
		address: yup.string().required(),
		district: yup.string().required(),
		province: yup.string().required(),
		country: yup.string().required(),
		phone: yup
			.string()
			.required()
			.test(
				"phoneNumberLength",
				"Telefon numarası geçerli formatta olmalıdır.",
				(val) => !val?.includes("_") && val?.length === 16
			),
	}),
});

export default PaymentInfoStepValidation;
